// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* 添加打印样式 */\n@media print {\n.fixed-header[data-v-6b12904f] {\r\n    display: table-header-group;\r\n    page-break-inside: avoid;\n}\r\n\r\n  /* 确保表头在每页重复 */\nthead[data-v-6b12904f] {\r\n    display: table-header-group;\n}\r\n\r\n  /* 防止行内分页 */\ntr[data-v-6b12904f] {\r\n    page-break-inside: avoid;\n}\r\n\r\n  /* 重置打印边距 */\nbody[data-v-6b12904f] {\r\n    margin: 0;\r\n    padding: 15mm;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
